module.exports = __webpack_public_path__ + "static/media/signDisclosures.5418bac2.svg";